import { useEffect, useState } from "react";
import { deleteUnbookedAudition, getBookedAuditionees, removeUserFromChoicesForAllRoles, setRoles, updateAuditionSlot } from "../../../../CastingBotFirebase";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import PrettifyDate from "../../../../_shoru_shared_library/functions/PrettifyDate";

function AuditionBookingsTab(props)
{
  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;
  const [slots, setSlots] = useState(castingData.slots);
  const [auditionees, setAuditionees] = useState(null);
  
  // A flag that is set to false when uploading/downloading information from the server
  const [editingEnabled, setEditingEnabled] = useState(true);

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(slots, userData.active_organisation_id, setAuditionees);
    // eslint-disable-next-line
  }, []);

  if(auditionees === null) return <SectionLoader />

  // If no slots are added, display message
  if(castingData.slots.length === 0)
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Audition Slots' 
        description="Add times or bookings to see them here"
      />
    )
  }

  return (
    <SubTabParent passData={props}>
      <SlotsDisplay 
        organisationId={userData.active_organisation_id}
        projectId={castingData.uid}
        slots={slots} 
        setSlots={setSlots} 
        auditionees={auditionees} 
        setAuditionees={setAuditionees}
        editingEnabled={editingEnabled}
        setEditingEnabled={setEditingEnabled}
        castingData={castingData}
        setCastingData={setCastingData}
      />
    </SubTabParent>
  )

}

export default AuditionBookingsTab;





function SlotsDisplay(props)
{
  const organisationId = props.organisationId;
  const projectId = props.projectId;
  const slots = props.slots;
  const setSlots = props.setSlots;
  const auditionees = props.auditionees;
  const setAuditionees = props.setAuditionees;
  const editingEnabled = props.editingEnabled;
  const setEditingEnabled = props.setEditingEnabled;
  const castingData = props.castingData;
  const setCastingData = props.setCastingData;

  slots.sort((a, b) => a.start < b.start? 1 : -1);
  slots.sort((a, b) => a.date > b.date? 1 : -1);
  var previousDate = null;
  let currentDate = new Date().toJSON().slice(0,10);

  let slotsDisplay = slots.map((slot, index) => {

    const slotBooked = (slot.auditionee_id !== null);
    const verdict = slot.notes.audition_verdict;
    const verdictColour = _getVerdictColour(verdict);
    var auditionee = {name: 'n/a', uid: slot.uid, email: slot.email, phone: 'New auditionee. Refresh page to view.', error: true};
    var dateChanged = false;

    // If the date has changed, make a note of this
    if(slot.date !== previousDate) {
      dateChanged = true;
      previousDate = slot.date;
    }

    // If the audition slot is booked, find the corresponding auditionee
    if(slotBooked) {
      auditionees.forEach((a) => {
         if(a.uid === slot.auditionee_id) auditionee = a;
      })
    }
    else if(slot.date < currentDate) return null;

    if(auditionee.name !== 'n/a') auditionee.error = false;

    return (
      <div>
        {dateChanged? (
          (slot.time_id === null)? (
            <h2 style={{marginTop: '20px'}}>Unbooked Auditions</h2>
          ) : (
            <h2 style={{marginTop: '20px'}}>{PrettifyDate(slot.date, true)}</h2>
          )
        ) : null}
        <div key={index} className={'console-audition-slot' + (props.narrow? '-narrow' : '') + (slotBooked? ' console-audition-slot-booked' : '') + (slot.recalled? ' console-audition-slot-recalled' : '')}>
        
          {slot.start}
          {slotBooked? (
            <div className='console-audition-slot-details' style={{color: verdictColour}}>
              {auditionee.name}
              <i>{auditionee.email}</i>
              <i style={{color: (verdictColour + '77')}}>{auditionee.phone}</i>
            </div>
          ) : (
            <div className='console-audition-slot-details'>
              <div style={{color: '#777777'}}>
                <i>Not Yet Booked</i>
              </div>
            </div>
          )}

          {slotBooked? (
            <div className={'console-audition-slot-booking-options' + (props.narrow? '-narrow' : '')}>
              {auditionee.error === false? (
                <select defaultValue={verdict} onChange={async(e) => { 
                  setEditingEnabled(false);
                  var newSlot = slot;
                  newSlot.notes.audition_verdict = e.target.value;
                  await updateAuditionSlot(newSlot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData);
                  setEditingEnabled(true);
                }} disabled={!editingEnabled} title='Verdict of audition'>
                  <option value='undetermined'>-</option>
                  <option value='excellent'>Excellent</option>
                  <option value='good'>Good</option>
                  <option value='ok'>Ok</option>
                  <option value='poor'>Poor</option>
                </select>
              ) : null}
              {auditionee.error === false? (
                <div className={'console-audition-slot-recall-box' + (props.narrow? '-narrow' : '')}>
                  <input defaultChecked={slot.recalled} type='checkbox' className='console-audition-slot-checkbox' onClick={async() => {
                      setEditingEnabled(false);
                      var newSlot = slot;
                      newSlot.recalled = !slot.recalled;
                      // If an auditionee is being moved out of the recall pool, they need to be removed from casting choices and groups
                      if(newSlot.recalled === false)
                      {
                        if(newSlot.notes.recall_verdicts.length > 0)
                        {
                          newSlot.notes.recall_verdicts = [];
                          alert('Auditionee has been removed from all recall groups they were added to');
                        }
                        const newRoles = removeUserFromChoicesForAllRoles(castingData.roles, auditionee.uid);
                        await setRoles(newRoles, organisationId, projectId, castingData, setCastingData);
                      }
                      await updateAuditionSlot(newSlot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData);
                      setEditingEnabled(true);
                    }}
                    disabled={!editingEnabled} 
                  />
                  {slot.recalled? (
                    <p style={{color: '#27ae60'}}>{props.narrow? null : 'In recall pool'}</p>
                  ) : (
                    <p className='console-audition-slot-not-recalled-text'>{props.narrow? null : 'Not recalled'}</p>
                  )}
                </div>
              ) : null}
              <FontAwesomeIcon icon={faTrash} title='Remove booking' style={{...{cursor: 'pointer'},...{color: '#c0392b'}}} onClick={async() => {
                setEditingEnabled(false);
                if(slot.time_id !== null)
                {
                  var newSlot = slot;
                  if(newSlot.recalled) {
                    if(newSlot.notes.recall_verdicts.length > 0) alert('Auditionee has been removed from all recall groups they were added to');
                    const newRoles = removeUserFromChoicesForAllRoles(castingData.roles, auditionee.uid);
                    await setRoles(newRoles, organisationId, projectId, castingData, setCastingData);
                  }
                  newSlot.notes = {audition_verdict: "undetermined", recall_verdicts: []};
                  newSlot.recalled = false;
                  newSlot.auditionee_id = null;
                  await updateAuditionSlot(newSlot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData);
                }
                else
                {
                  await deleteUnbookedAudition(slot, slots, organisationId, projectId, setSlots, setAuditionees, setCastingData);
                }
                setEditingEnabled(true);
              }} disabled={!editingEnabled} />
            </div>
          ) : null}

        </div>
      </div>
    )

  })

  return (
    <div className='console-audition-slots-container'>
      {slotsDisplay}
    </div>
  )
}



const _getVerdictColour = (verdict) => {
  if      (verdict === 'undetermined')    return '#cccccc'; // Light grey
  else if (verdict === 'poor')            return '#e74c3c'; // Red
  else if (verdict === 'ok')              return '#e67e22'; // Orange
  else if (verdict === 'good')            return '#f1c40f'; // Yellow
  else                                    return '#2ecc71'; // Green
}